import { format } from 'date-fns-tz';

export const DEFAULT_DATETIME_FORMAT = 'dd.MM.yyyy HH:mm:ss';
export const DEFAULT_DATE_FORMAT = 'dd.MM.yyyy';

export function defaultDatetimeFormatter(
    value?: Date,
    emptyText = '',
    dateTimeFormat: string = DEFAULT_DATETIME_FORMAT
): string {
    if (!value) {
        return emptyText;
    }
    return format(value, dateTimeFormat);
}

export function defaultDateFormatter(value: Date, emptyText = '', dateFormat: string = DEFAULT_DATE_FORMAT): string {
    if (!value) {
        return emptyText;
    }
    return format(value, dateFormat);
}

export function dateTimeFilter(
    value: unknown,
    emptyText = '',
    dateTimeFormat: string = DEFAULT_DATETIME_FORMAT
): string {
    if (!value) {
        return emptyText;
    }

    if (typeof value === 'string') {
        return defaultDatetimeFormatter(new Date(value), emptyText, dateTimeFormat);

        // parses ISO 8601 string into Date, due to date-fns library, all conversion scenarios should be supported
        // const date = parseISO(value) // + "Z", undefined Kind in .NET DateTime results in missing Z suffix
        // const timeZone = 'Europe/Brussels'
        // const zonedDate = utcToZonedTime(date, timeZone) //this translation step is only necessary if the Date is UTC, not Local
        // return defaultDatetimeFormatter(zonedDate, emptyText);
    }
    if (value instanceof Date) {
        return defaultDatetimeFormatter(value, emptyText, dateTimeFormat);
    }
    return emptyText;
}

export function dateFilter(value: unknown, emptyText = '', dateFormat: string = DEFAULT_DATE_FORMAT): string {
    if (!value) {
        return emptyText;
    }

    if (typeof value === 'string') {
        return defaultDateFormatter(new Date(value), emptyText, dateFormat);

        // parses ISO 8601 string into Date, due to date-fns library, all conversion scenarios should be supported
        // const date = parseISO(value) // + "Z", undefined Kind in .NET DateTime results in missing Z suffix
        // const timeZone = 'Europe/Brussels'
        // const zonedDate = utcToZonedTime(date, timeZone) //this translation step is only necessary if the Date is UTC, not Local
        // return defaultDateFormatter(zonedDate, emptyText);
    }
    if (value instanceof Date) {
        return defaultDateFormatter(value, emptyText, dateFormat);
    }
    return emptyText;
}
